import { Box } from "@mui/material";

interface MetabaseIframeProps {
  src: string;
  title: string;
  /** Saved filter values to apply, added to the embed URL as the query string. */
  params?: Record<string, string>;
  /** Dashboard tab to open, like "4-orders-list". */
  tab?: string | null;
}

const buildIframeSrc = (
  src: string,
  params?: Record<string, string>,
  tab?: string | null,
): string => {
  const [base] = src.split("#");

  const search = new URLSearchParams(params ?? {});
  if (tab) {
    search.set("tab", tab);
  }
  const query = search.toString();

  return `${base}${query ? `?${query}` : ""}#bordered=false&titled=false`;
};

export default function MetabaseIframe({
  src,
  title,
  params,
  tab,
}: MetabaseIframeProps) {
  return (
    <Box
      component="iframe"
      src={buildIframeSrc(src, params, tab)}
      title={title}
      sx={{
        flex: 1,
        width: "100%",
        height: "100%",
        border: "none",
        display: "block",
        backgroundColor: "background.paper",
      }}
    />
  );
}
